// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../shared.module.css\"","lg":"992px","container":"SectionTitle_container__NYhks","title":"SectionTitle_title__3QhE1","subtitle":"SectionTitle_subtitle__3X2sW"};